import { ProviderModel } from './provider.model';

export class ProviderPagedResult {
    public resultSet: ProviderModel[];
    public currentPage: number;
    public pageSize: number;
    public rowCount: number;
}